import { logFormData } from 'shared/lib/logFormData';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TContactsFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setContactsInfo } from 'entities/creditForm';

import { ContactsInfoTexts } from 'features/UpdateContactsInfo/ContactsInfo.texts';

export const submitContactsForm =
  (actualData: TContactsFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('ContactsInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([1], ContactsInfoTexts, 'manual', analyticsOverrides));
    dispatch(setContactsInfo({ data: actualData, isFullFilled: true }));
  };
